import { is } from '@convenia/helpers'

export const getIsRequired = (fieldSchema = {}) => {
  const { validation } = fieldSchema
  if (is(validation, 'String')) return validation.includes('required')

  return validation?.required
}

export const getIsHidden = (fieldSchema = {}, formValue = {}) => {
  if (is(fieldSchema.hide, 'Function'))
    return fieldSchema.hide(formValue)

  return fieldSchema.hide
}

export const getIsDisabled = ({
  disabled,
  fieldSchema = {},
  fieldOptions = [],
  formValue = {},
  isRequired
}) => {
  if (disabled) return disabled

  if (is(fieldSchema.isDisabled, 'Function'))
    return fieldSchema.isDisabled(formValue)

  const noSelectableOptions = !!fieldSchema.options && !(fieldOptions || []).length
    && fieldSchema?.nullable
    && !!isRequired

  return fieldSchema.disabled
    || noSelectableOptions
}

export const shouldSkipValidation = ({ isHidden, isDisabled, forceValidation }) => {
  return isHidden || (!forceValidation && isDisabled)
}
